import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';
import api from '../services/api';

const LanguageContext = createContext();

const LANGUAGE_KEY = 'eden_lang';

export function LanguageProvider({ children }) {
  const [languages, setLanguages] = useState([]);
  const [activeLang, setActiveLang] = useState(
    () => localStorage.getItem(LANGUAGE_KEY) || null
  );
  const [content, setContent] = useState({});

  // Fetch available languages and set default if not stored in localStorage
  useEffect(() => {
    api.get('/languages').then((res) => {
      const langs = res.data;
      setLanguages(langs);
      if (!localStorage.getItem(LANGUAGE_KEY) && langs.length > 0) {
        const def = langs.find(l => l.is_default) || langs[0];
        setActiveLang(def.code);
      }
    }).catch(() => {});
  }, []);

  // Fetch site content for current language
  useEffect(() => {
    if (!activeLang) return;
    api.get(`/content?lang=${activeLang}`).then((res) => {
      setContent(res.data || {});
    }).catch(() => {});
  }, [activeLang]);

  const switchLanguage = useCallback((code) => {
    setActiveLang(code);
    localStorage.setItem(LANGUAGE_KEY, code);
  }, []);

  // t(key, fallback) — get a translated string from site settings
  const t = useCallback(
    (key, fallback = '') => content[key] || fallback,
    [content]
  );

  // Memoize value pentru a preveni re-render pe toti consumatorii la fiecare render
  const value = useMemo(
    () => ({ activeLang, languages, switchLanguage, t, content }),
    [activeLang, languages, switchLanguage, t, content]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
